var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApDeploymentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H35C40.5228 0 45 4.47715 45 10V35C45 40.5228 40.5228 45 35 45H10C4.47715 45 0 40.5228 0 35V10Z",
    fill: "#FFEAF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.375C14.4518 23.6664 16.7342 24.7741 18.48 26.52C20.2259 28.2658 21.3336 30.5482 21.625 33C22.8404 32.2993 23.857 31.3003 24.5788 30.0973C25.3006 28.8943 25.7037 27.5271 25.75 26.125C28.0588 25.3128 30.0749 23.8342 31.5434 21.8763C33.0118 19.9183 33.8668 17.5688 34 15.125C34 14.031 33.5654 12.9818 32.7918 12.2082C32.0182 11.4346 30.969 11 29.875 11C27.4312 11.1332 25.0817 11.9882 23.1237 13.4566C21.1658 14.9251 19.6872 16.9412 18.875 19.25C17.4729 19.2963 16.1057 19.6994 14.9027 20.4212C13.6997 21.143 12.7007 22.1596 12 23.375",
    stroke: "#F9538F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0332 25C14.6571 25.7769 13.5443 26.9471 12.8376 28.3606C12.1308 29.7741 11.8623 31.3664 12.0665 32.9335C13.6336 33.1377 15.2259 32.8692 16.6394 32.1624C18.0529 31.4557 19.2231 30.3429 20 28.9668",
    stroke: "#F9538F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 19C28.3284 19 29 18.3284 29 17.5C29 16.6716 28.3284 16 27.5 16C26.6716 16 26 16.6716 26 17.5C26 18.3284 26.6716 19 27.5 19Z",
    stroke: "#F9538F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApDeploymentIcon);
export default __webpack_public_path__ + "static/media/ap-deployment-icon.d98c40b11301309e4ecfa247d63a4d23.svg";
export { ForwardRef as ReactComponent };